import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { verifyMagicLink } from "../api";
import { setSessionToken } from "../utils/auth";
import { loadSubscriptions } from "../utils/subscriptionsStore";

// Landing page for the magic-link email: /verify?token=... - exchanges the one-time
// token for a session token, then redirects home.
function VerifyPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("verifying");

  useEffect(() => {
    const token = searchParams.get("token");
    if (!token) {
      setStatus("error");
      return;
    }
    verifyMagicLink(token)
      .then(async (result) => {
        setSessionToken(result.session_token);
        await loadSubscriptions();
        setStatus("success");
        setTimeout(() => navigate("/"), 1200);
      })
      .catch(() => setStatus("error"));
  }, [searchParams, navigate]);

  return (
    <div className="text-center mt-5">
      {status === "verifying" && <p>Signing you in…</p>}
      {status === "success" && <p>✅ Signed in! Redirecting…</p>}
      {status === "error" && (
        <p>This sign-in link is invalid or has expired. Go back and request a new one.</p>
      )}
    </div>
  );
}

export default VerifyPage;
